export default ({ Factory }) => ({

  /**
   * Проверка оплаты канала
   * @param {String} id - идентификатор канала
   */
  check: (id) => Factory.check[id].get(),

  /**
   * Инициализация оплаты канала
   * @param {String} id - идентификатор канала
   */
  init: (id) => Factory.init[id].post(),

  /**
   * Получение списка оплат
   * @param {Number} start - начало списка
   * @param {Number} page - страница списка
   */
  list: (start, page) => Factory.list[`?start=${start}&page=${page}`].get()
})